import React, { useState } from "react";
import discordpng from '../images/new/team/discord.png'
import teamTwitter from '../images/new/team/twitter.svg'
import instaIcon from '../images/new/coaches/insta.svg'
import linkIcon from '../images/new/coaches/link.svg'
import linkedinIcon from '../images/linkedin.svg'
import shahab from '../images/new/team/shahab.png'
import kat from '../images/new/team/kat.png'
import lana from '../images/new/team/lana.png'
import shell from '../images/new/team/shell.png'
import nicole from '../images/new/team/nicole.png'
import TeamCard from "./TeamCard";
const teamData = [
  {
    id: 1,
    image: shahab,
    imgAlt: "Shahab",
    name: "Shahab",
    position: "The Project Architect",
    discordIcon: discordpng,
    twitterIcon: teamTwitter,
    instaIcon: instaIcon,
    linkIcon: linkIcon,
    linkedinIcon: linkedinIcon,
    detail: "Shahab, an accomplished business owner and campaign strategist, with a history in the wellness space. Marketing Strategist for Liquid Death and their MHDC. Founder of Muscle Laboratories, a first of its kind wellness and recovery sanctuary. Shahab is a wellness enthusiast who devotes his free time in motivating his communities in pursuing a healthy and positive life. Previous advisory roles with NFTGo, WeMeta, and Meta Fighters.",
    discordLink: "/",
    linkedinLink: "https://www.linkedin.com/in/shahabs/",
    twitterLink: "https://twitter.com/shahabs",
    insta: '/',
    website: '/',
    hasDiscord: false,
    hasLinkedin: true,
    hasTwitter: true,
    hasInsta: false,
    hasWebsite: false,
  },
  {
    id: 2,
    image: kat,
    imgAlt: "kat",
    name: "kat",
    position: "The Project Artist",
    discordIcon: discordpng,
    twitterIcon: teamTwitter,
    instaIcon: instaIcon,
    linkIcon: linkIcon,
    detail: "Cosmic Friend has been an artist for over 15 years, producing illustrations, textile designs, and art for brands with notable clients, such as Coca-Cola, Emirates Airlines, Proctor & Gamble, and Random House. Cosmic's life is full of color, toys, rainbows, plants, magic, and patterns, all of which inspire her artistic creations and can be seen in the magical touch she adds to each piece.",
    discordLink: "/",
    twitterLink: "https://twitter.com/cosmicfriendnft",
    insta: '/',
    website: '/',
    hasDiscord: false,
    hasTwitter: true,
    hasInsta: false,
    hasWebsite: false,
  },
  {
    id: 3,
    image: lana,
    imgAlt: "lana",
    name: "Lana",
    position: "The Heal App Director",
    discordIcon: discordpng,
    twitterIcon: teamTwitter,
    instaIcon: instaIcon,
    linkIcon: linkIcon,
    detail: `Lana Maile, a serial entrepreneur <strong>Soul Enhancer </strong>, with a background in professional consulting and coaching. She is a certified Integrative Nutritionist and speaker who built a business mentoring over 350 coaches in the health and wellness space. Lana is dedicated to help others turn their dreams into reality.`,
    discordLink: "/",
    twitterLink: "https://www.twitter.com/itslanamaile",
    insta: 'https://www.instagram.com/itslanamaile',
    website: 'https://www.lanamaile.com',
    hasDiscord: false,
    hasTwitter: true,
    hasInsta: true,
    hasWebsite: true,
  },
  {
    id: 4,
    image: shell,
    imgAlt: "shell",
    name: "Shell",
    position: "The Project Manager",
    discordIcon: discordpng,
    twitterIcon: teamTwitter,
    instaIcon: instaIcon,
    linkIcon: linkIcon,
    detail: "Michelle Lopez, owner of &#x22;BakeShell&#x22; created her dream life of owning a Gluten-Free and Vegan Bakery after 8 years in the mental health industry. When not in the bakery, Michelle is committed to helping others believe in their value and experience life unapologetically.",
    discordLink: "/",
    twitterLink: "https://twitter.com/Moonshell__",
    insta: 'https://www.instagram.com/bybakeshell_/',
    website: '/',
    hasDiscord: false,
    hasTwitter: true,
    hasInsta: true,
    hasWebsite: false,
  },
  {
    id: 5,
    image: nicole,
    imgAlt: "nicole",
    name: "Nicole",
    position: "The Social Strategist",
    discordIcon: discordpng,
    twitterIcon: teamTwitter,
    instaIcon: instaIcon,
    linkIcon: linkIcon,
    detail: "Nicole Vicente, a “entrepreneurial spirit”  experienced in brand development and marketing. Previously working in venture capital, she led a psychedelic wellness company with focus on addiction and mental health. While shifting to full time web3, Nicole has been a leading female voice for crypto entrepreneurs featured in Bloomberg and The Block.",
    discordLink: "/",
    twitterLink: "https://twitter.com/cryptonikole",
    insta: '/',
    website: '/',
    hasDiscord: false,
    hasTwitter: true,
    hasInsta: false,
    hasWebsite: false,
  },
]
function Team() {
  const [active, setActive] = useState(null);
  const handleFlipping = (index) => {
    if (active === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  }
  return (
    <section className="full-height" id="team">
      <div className="wrapper">
        <h2 data-aos="fade-up" data-aos-delay="300">TEAM</h2>
        <div className="teams" >
          {teamData.map((teamD, index) => {
            return (
              <TeamCard
                key={index}
                active={active}
                handleFlipping={handleFlipping}
                teamD={teamD}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Team;
